(()=>{
  const priceSelectors=[
    '[data-dpv2-current-price]',
    '[data-dpv2-compare]',
    '[data-dpv2-bundle-total]',
    '[data-dpv2-bundle-original]',
    '[data-dpv2-per-item]',
    '[data-dpv2-save-amount]',
    '[data-dpv2-sticky-price]'
  ].join(',');

  function addCurrencyLabels(root=document){
    root.querySelectorAll(priceSelectors).forEach(el=>{
      if(el.hidden)return;
      const t=(el.textContent||'').trim();
      if(t && !/\bUSD$/i.test(t)) el.textContent=t+' USD';
    });
  }

  function selectBundle(row){
    const input=row.querySelector('input[name="deko_pack"]');
    if(!input || input.disabled)return;
    if(!input.checked){
      input.checked=true;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }else{
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    row.closest('[data-dpv2-product]')?.querySelectorAll('[data-dpv2-bundle]').forEach(card=>{
      const radio=card.querySelector('input[name="deko_pack"]');
      card.classList.toggle('is-selected',!!radio?.checked);
    });
    requestAnimationFrame(()=>addCurrencyLabels(row.closest('[data-dpv2-product]')||document));
    setTimeout(()=>addCurrencyLabels(row.closest('[data-dpv2-product]')||document),50);
  }

  function bind(root=document){
    root.querySelectorAll('[data-dpv2-bundle]').forEach(row=>{
      if(row.dataset.bundleRescueReady==='true')return;
      row.dataset.bundleRescueReady='true';
      row.addEventListener('click',e=>{
        if(e.target.closest('a,button,select'))return;
        e.preventDefault();
        selectBundle(row);
      },true);
    });
    addCurrencyLabels(root);
  }

  function init(){
    bind(document);
    const obs=new MutationObserver(muts=>{
      let needsBind=false,needsMoney=false;
      for(const m of muts){
        if(m.type==='childList')needsBind=true;
        const el=m.target?.nodeType===1?m.target:m.target?.parentElement;
        if(el?.closest?.('[data-dpv2-product]'))needsMoney=true;
      }
      if(needsBind)bind(document);
      if(needsMoney)requestAnimationFrame(()=>addCurrencyLabels(document));
    });
    obs.observe(document.documentElement,{subtree:true,childList:true,characterData:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();